export class EqualizeUserBidForAuctionRequest{
    public userId! : string;
    public auctionId! : number;
    public bidderId! : string;
    public reason! : string;
}